import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormFlex,
  title: 'Form Flex',
  category: ComponentCategory.FormControls,
  droppable: true,
};
